import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/App.stylesheet.scss";
import App from "./App";
import * as Sentry from "@sentry/react";

const isDevelopment = process.env.NODE_ENV === "development";

if (!isDevelopment) {
  Sentry.init({
    dsn: "https://c8fe3ee3246aee60a0c5b7b0da89ac6c@o4510937850576896.ingest.us.sentry.io/4510937957728256",
    sendDefaultPii: true,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(<App />);
